import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["viewMode", "editMode", "form"]
  static values = {
    id: Number,
    postId: Number,
    mode: String
  }

  connect() {
    this.showCurrentMode()
  }

  enterEditMode(event) {
    event.preventDefault()
    this.modeValue = "edit"
    this.showCurrentMode()
  }

  cancelEdit(event) {
    event.preventDefault()
    this.modeValue = "view"
    this.showCurrentMode()
  }

  save(event) {
    event.preventDefault()
    const formData = new FormData(this.formTarget)

    fetch(`/admin/posts/${this.postIdValue}/blocks/${this.idValue}`, {
      method: 'PATCH',
      headers: {
        'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content,
        'Accept': 'text/vnd.turbo-stream.html'
      },
      body: formData
    })
    .then(response => response.text())
    .then(html => {
      Turbo.renderStreamMessage(html)
      this.modeValue = "view"
    })
    .catch(error => {
      console.error('Error saving block:', error)
    })
  }

  showCurrentMode() {
    if (this.modeValue === "edit") {
      this.viewModeTarget.classList.add('d-none')
      this.editModeTarget.classList.remove('d-none')
    } else {
      this.viewModeTarget.classList.remove('d-none')
      this.editModeTarget.classList.add('d-none')
    }
  }

  modeValueChanged() {
    this.showCurrentMode()
  }
}
